/* Types */
import { Mode } from '@/types/main'

/**
 * Формируем и отдаем API_URL в зависимости от domain 1-ого ур. (ru, kg, com...)
 * @param apiUrl - публичный api url для запросов
 * @param apiBaseUrlKg - базовый api url для kg домена
 * @param mode - окружение приложения
 * @param host - домен подключения
 */
export const getApiUrl = (
  apiUrl: string,
  apiBaseUrlKg: string,
  mode: Mode,
  host: string,
) => {
  const kgFirstLevelDomain = 'kg'

  if ([Mode.DEVELOPMENT, Mode.BRANCH].includes(mode)) return apiUrl

  /*
    Если это kg домен -> возвращаем отдельный apiBaseUrlKg
    Делаем это потому, что kg домен для нас не является доменом первого уровня
    Пример staging окружения - https://bishkek.frfrstaging-kg.ru
  */
  if (
    host.includes(kgFirstLevelDomain) &&
    [Mode.STAGING, Mode.RC].includes(mode)
  )
    return apiBaseUrlKg

  if ([Mode.STAGING, Mode.RC, Mode.RELEASE].includes(mode)) {
    // Получаем домен 1 уровня
    const domain = getFirstLevelDomain(host, mode)

    // Заменяем домен первого уровня для API_URL
    return getSplicedHost(apiUrl, domain)
  }
}
